import { Flex, Text, Title } from '@mantine/core';
import { IconDeviceMobile, IconRotate2 } from '@tabler/icons-react';
import cn from 'classnames';
import * as React from 'react';

import { useIsPhoneLandscape } from '@/hooks/useIsPhoneLandscape';
import { useLockBodyScroll } from '@/hooks/useLockBodyScroll';

import s from './RotateDeviceStub.module.scss';

type RotateDeviceStubProps = {
  className?: string;
};

const RotateDeviceStub: React.FC<RotateDeviceStubProps> = ({ className }) => {
  const isPhoneLandscape = useIsPhoneLandscape();

  useLockBodyScroll({ lock: isPhoneLandscape });

  if (!isPhoneLandscape) {
    return null;
  }

  return (
    <Flex align="center" justify="center" className={cn(s.root, className)}>
      <div className={s.root__card}>
        <div className={s.root__icon}>
          <IconDeviceMobile className={s['root__icon-phone']} />
          <IconRotate2 />
        </div>
        <Title size="h3" className={s.root__title}>
          Переверните устройство
        </Title>
        <Text size="sm" c="gray" className={s.root__description}>
          Для работы сервиса используйте вертикальную ориентацию экрана.
        </Text>
      </div>
    </Flex>
  );
};

export default React.memo(RotateDeviceStub);
